var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useConfig } from "./useConfig";
import { useCreditAccounts } from "../const/syfApiQueries";
var useCurrentAccount = function (selectedAccountId) {
    var profileConfig = useConfig();
    var _a = useCreditAccounts(profileConfig), accountQuery = _a.data, isAccountsLoading = _a.isLoading, isError = _a.error;
    var accountError = Boolean(isError);
    var accountErrorMessage = isError === null || isError === void 0 ? void 0 : isError.message;
    var options = [];
    var accounts = [];
    if ((accountQuery === null || accountQuery === void 0 ? void 0 : accountQuery.accounts) && accountQuery.accounts.length) {
        options = accountQuery === null || accountQuery === void 0 ? void 0 : accountQuery.accounts.map(function (account) { return ({
            label: "".concat(account.product.displayName, "...").concat(account.info.accountLast4),
            value: account.info["cipher.accountId"],
        }); });
        accounts = accountQuery === null || accountQuery === void 0 ? void 0 : accountQuery.accounts;
    }
    var selectedAccount = accounts.find(function (item) {
        var accountId = item.info["cipher.accountId"];
        return accountId === selectedAccountId;
    });
    var selectedOption = options.find(function (item) {
        var value = item.value;
        return value === selectedAccountId;
    });
    if (!selectedAccount) {
        selectedAccount = __assign({}, accounts[0]);
    }
    if (!selectedOption) {
        selectedOption = __assign({}, options[0]);
    }
    return {
        accountErrorMessage: accountErrorMessage,
        accountError: accountError,
        accountsList: accounts,
        selectedAccount: selectedAccount,
        selectedAccountOption: selectedOption,
        accountsOptions: options,
        isLoading: isAccountsLoading,
    };
};
export default useCurrentAccount;
